import React, { useState, useEffect, useCallback, useMemo } from "react";
import Style from "./SelectProductDirectly.module.css";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Grouping from "../../Component/Grouping/Grouping";
import { getCategoryApi, getSearchSuperyApi } from "../../Api/ClientServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { Link } from "react-router-dom";
import { errorToast } from "../../Toast/Toast";

const SelectProductDirectly = () => {
  const [data, setData] = useState(undefined);
  const [searchValue, setSearchValue] = useState([]);
  const [showSearchPart, setShowSearchPart] = useState(false);

  // Fetch category data on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      getCategoryApi((succ, res) => {
        if (succ) {
          if (res.status === 0) {
            errorToast(res.message);
          } else {
            setData(res.categories);
          }
        } else {
          console.error(res);
        }
      });
    };
    fetchCategories();
  }, []);

  // Function to handle search
  const getSearchSupermarket = useCallback((value) => {
    if (!value.trim()) {
      setSearchValue([]);
      setShowSearchPart(false);
      return;
    }

    getSearchSuperyApi(value, (succ, res) => {
      if (succ) {
        if (res.status === 0 || !res.product || res.status === -2) {
          setSearchValue([]);
          setShowSearchPart(true);
        } else {
          setSearchValue(res.product);
          setShowSearchPart(true);
        }
      } else {
        errorToast(res.message);
        setSearchValue([]);
        setShowSearchPart(false);
      }
    });
  }, []);

  // Loading or grouping content
  const categoryContent = useMemo(() => {
    return data === undefined ? (
      <div className={Style.loading2Test}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    ) : (
      <Grouping data={data} />
    );
  }, [data]);

  return (
    <div>
      <BurgerMenuTitle title={"انتخاب کالا"} />
      <div className={Style.searchHolder}>
        <input
          className={Style.search}
          placeholder={"جستجو ..."}
          onChange={(e) => getSearchSupermarket(e.target.value)}
          type={"text"}
        />
        {showSearchPart && searchValue.length > 0 && (
          <ul className={Style.searchResult}>
            {searchValue.map((item) => (
              <Link
                to={{
                  pathname: `/product/${item.id}/${item.supplier_id}`,
                  state: item.id,
                }}
                className={Style.resultItem}
                key={item.id} // Use a unique key
              >
                <div className={Style.imgHolder}>
                  <img
                    src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                    alt={item.name}
                  />
                </div>
                <div className={Style.productInfo}>
                  <h3 className={Style.productName}>{item.name}</h3>
                  <div className={Style.priceHolder}>
                    {item.off_price !== 0 && (
                      <h3 className={Style.offPrice}>{item.off_price} تومان</h3>
                    )}
                    <h3
                      className={
                        item.off_price !== 0 ? Style.ofprice : Style.price
                      }
                    >
                      {item.price} تومان
                    </h3>
                  </div>
                </div>
              </Link>
            ))}
            <div className={Style.opacityPart}></div>
          </ul>
        )}
      </div>
      <div className={Style.Grouping}>
        <h2 className={Style.title}>دسته بندی</h2>
        {categoryContent}
      </div>
    </div>
  );
};

export default SelectProductDirectly;
